// extracted by mini-css-extract-plugin
export default {"header":"pI","light":"qI","dark":"rI","headertitle":"sI","fname":"tI","headerContent":"uI","right":"vI","descriptionwrapper":"wI","appear":"xI","second":"yI","third":"zI","forth":"AI"};
    if(module.hot) {
      // 1714654895680
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  